(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview-hero/assets/javascripts/content/competition-finished.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview-hero/assets/javascripts/content/competition-finished.js');

'use strict';

const CompetitionLogo = svs.components.marketplaceCompetition.overviewHero.common.CompetitionLogo;
const resolveCompetitionName = svs.components.marketplaceCompetition.helpers.resolveCompetitionName;
const CompetitionFinished = _ref => {
  let competition = _ref.competition;
  const compName = resolveCompetitionName(competition);
  return React.createElement("div", {
    className: "competition-overview-hero competition-finished"
  }, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("h2", {
    className: "overview-hero-title"
  }, compName, ' ', React.createElement("span", null, "\xE4r slut f\xF6r i \xE5r.")), React.createElement("div", {
    className: "overview-hero-sub"
  }, React.createElement("p", null, "Tack alla deltagare."))));
};
setGlobal('svs.components.marketplaceCompetition.overviewHero.content.CompetitionFinished', CompetitionFinished);

 })(window);